import {
  checkoutV202604,
  type operations,
} from "@fluid-app/checkout-api-client";
import { createPublicCheckoutApiClient } from "@/lib/checkout-api-client";

export {
  agreementSchema,
  agreementsResponseSchema,
  type Agreement,
} from "@/networking/agreements.types";

type StoreAgreementResponse =
  operations["checkout_v2026_04_get_store_agreement"]["responses"][200]["content"]["application/json"];

export async function fetchAgreements(
  id: string,
): Promise<StoreAgreementResponse> {
  return checkoutV202604.checkout_v2026_04_get_store_agreement(
    createPublicCheckoutApiClient(),
    id,
  );
}
